import { IconWrapper, ISvgIconProps } from "@icon-park/svg/lib/runtime";

export default IconWrapper(
  "EqualSign",
  (props: ISvgIconProps) =>
    `<svg width=${props.size} height=${props.size} viewBox="0 0 48 48" fill="none">` +
    `<path style="transform: scale(3)" fill="${props.colors[0]}" d="M2.668 6.667c0-.369.298-.667.667-.667h9.333a.667.667 0 010 1.333H3.335a.667.667 0 01-.667-.666zM2.668 9.333c0-.368.298-.666.667-.666h9.333a.667.667 0 110 1.333H3.335a.667.667 0 01-.667-.667z" />` +
    "</svg>"
);
